import {keepPreviousData, queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import type {GetAccountsRequest} from '../types';

import {getAccounts} from './getAccounts';

export const accountsQueryOptions = (req: GetAccountsRequest) =>
  queryOptions({
    queryKey: keys.accounts.list(req),
    queryFn: () => getAccounts(req),
    placeholderData: keepPreviousData,
  });
